import Cookies from "js-cookie"
import { Controller } from "@hotwired/stimulus"

class CourrierPickupTourController extends Controller {
  markAsShipped(event) {
    fetch(event.currentTarget.dataset.url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": Cookies.get("csrftoken"),
      },
    })
    const target =
      event.target.parentElement.parentElement.querySelector(".swipe-item")
    window.requestAnimationFrame(() => {
      target.style.transition = "transform .2s ease-in"
      target.style.transform = null
    })
  }
}
export default CourrierPickupTourController
